export const CHATBOT_UNI_BO = "bo_chatbot_uni"
export const CHATBOT_STUDENTS = "fo_chatbot_students"
